import type { Validator } from '../types/validator';

export const required: Validator = {
  key: 'required',
  error: 'Este campo es requerido',
  validate: (value) => typeof value === 'string' 
    ? value.trim() !== ''
    : value !== undefined && value !== null
};

export const phone: Validator = {
  key: 'phone',
  error: 'Número de teléfono invalido',
  validate: (value) => /^\d{10,}$/.test(value as string)
};

export const email: Validator = {
  key: 'email',
  error: 'Correo electrónico invalido',
  validate: (value) => /^[\d\w-]{2,}@[\d\w]{2,}\.[\d\w]{2,}$/.test(value as string)
};

export function minLength(min: number, error?: string): Validator {
  return {
    key: 'min-length',
    error: error ?? 'Valor minimo',
    validate: (value) => (
      (Array.isArray(value) || typeof value === 'string') && 
      value.length >= min
    )
  };
};

minLength.key = 'min-length';
